import { useQuery } from '@apollo/client';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useAppContext } from '~/contexts';
import { AuthorizableType } from '~/generated/graphql';
import { assertIsKeyOf } from '~/lib/assert';
import { AuthorizableAuthDocument } from '../ContentFolderView.generated';

export const useCanDestroySelected = (selectedIds: GridRowSelectionModel) => {
  const { currentNetwork } = useAppContext();

  const items = useMemo(
    () =>
      (selectedIds as string[]).flatMap((compositeId) => {
        const [typename, id] = compositeId.split('-');
        assertIsKeyOf(typename, AuthorizableType);
        return [{ id: Number(id), type: AuthorizableType[typename] }];
      }),
    [selectedIds],
  );

  const { data } = useQuery(AuthorizableAuthDocument, {
    variables: { networkId: currentNetwork.id, items },
    skip: selectedIds.length === 0,
  });

  if (items.length === 0) return true;

  return data?.network?.authorizable.every((item) => item.canDestroy.value) ?? true;
};
